initBlocksAnimation( document.querySelectorAll('.animate__init') )

function initBlocksAnimation( blockElements ) {
    blockElements.forEach( ( blockElement ) => {
        setObserverToBlock( blockElement )
    } )
}

function setAnimateToBlock( blockElement ) {
    if ( ! blockElement.classList.contains( 'animate__animated' ) ) {
        const animateType = blockElement.dataset.animate

        if ( typeof animateType !== 'undefined' ) {
            blockElement.classList.add('animate__animated', `animate__${animateType}`)
        }
    }
}

function setObserverToBlock( blockElement ) {
    /**
     * Вычисляем коэффициент пересечения, при котором
     * будем считать, что текущий элемент виден
     * Может быть в диапазоне [0, 1],
     * 0 - минимальная видимость блока
     * 1 - весь блок находится полностью в области просмотра
     * @type {Number}
     */
    const threshold = 0.1

    /**
     * Устанавливаем наблюдателя с нужными параметрами
     * чтобы менять метаданные записи и отсылать аналитику
     * @param  {Element} blockElement элемент записи
     * @param  {Function} ( observer, blockElementEntry )
     * callback-функция, которая будет выполняться
     * при входе/выходе в пересечение
     * @param  {Object} объект с параметрами для наблюдателя
     * где передаем параметр threshold
     */
    setObserverOnIntersect(
        blockElement,
        ( observer, blockElementEntry ) => {
            /**
             * При пересечении
             */
            if ( blockElementEntry.isIntersecting ) {
                /**
                 * Берем элемент записи
                 * @type {Element}
                 */
                const blockElementEl = blockElementEntry.target

                /**
                 * Анимируем блок
                 */
                setAnimateToBlock( blockElementEl )
            }
        },
        {
            threshold: threshold
        }
    );
}

/**
 * Инициализируем наблюдателя по пересечению переданного элемента c видимой областью, если в параметрах observeOptions не передан другой элемент
 * @param {Element}  observeElement элемент для наблюдения
 * @param {Function} observingFunc  callback-функция
 * @param {Object}   observeOptions объект с параметрами
 */
function setObserverOnIntersect( observeElement, observingFunc = ( observer, entry ) => {}, observeOptions = {} ) {
    /**
     * Создаем экземпляр класса для отслеживания
     */
    const observer = new IntersectionObserver( ( entries, observer ) => {
        /**
         * Перебираем все элементы и применяем callback-функцию
         */
        entries.forEach( entry => {
            observingFunc( observer, entry )
        } )
    }, observeOptions )

    /**
     * Инициализируем отслеживание
     */
    observer.observe( observeElement )
}